import { useIntersectionObserver } from "hooks/index";
import { RefObject, useCallback, useEffect, useState } from "react";

type useScrollProps = {
  containerRef: RefObject<Element>;
  isLoading: boolean;
  hasMoreData?: boolean;
  fetchMore: () => void;
};

export default function useScroll({
  containerRef,
  isLoading,
  hasMoreData,
  fetchMore,
}: useScrollProps) {
  const [triggerElement, setTriggerElement] = useState<Element | null>(null);

  const entry = useIntersectionObserver(triggerElement, {
    root: containerRef.current,
  });
  const [visibleAt, setVisibleAt] = useState<Date>(new Date());
  const [fetchedAt, setFetchedAt] = useState<Date>(new Date());

  const isVisible = Boolean(entry?.isIntersecting);

  useEffect(() => {
    if (isVisible) {
      setVisibleAt(new Date());
    }
  }, [isVisible]);

  useEffect(() => {
    if (isVisible && !isLoading && (fetchedAt < visibleAt || hasMoreData)) {
      fetchMore();
      setFetchedAt(new Date());
    }
  }, [isLoading, isVisible, fetchMore, fetchedAt, visibleAt, hasMoreData]);

  const refCallback = useCallback((node: Element | null) => {
    setTriggerElement(node);
  }, []);

  return refCallback;
}
